import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

import {EmpresaResponse, EmpresasResponse} from "../models/empresa.model";
import {ResourceService} from "../../shared/comun/services/resource.service";
import {appService} from "../../credentials";

@Injectable()
export class EmpresaService {

    constructor(private http: HttpClient,
                private resourceService:ResourceService) {
    }

    getEmpresa(token, codigo) {
        let options = this.resourceService.getRequestOptions(token);
        return this.http.get<EmpresaResponse>(appService.ws_recuadacion_empresa_detalle + codigo, options)
    }

    getEmpresas() {
        let options = this.resourceService.getRequestOptionsSinToken();
        return this.http.get<EmpresasResponse>(appService.ws_core_empresa_lista, options)
    }

    empresa_add_params(params={}){
        let empresa = this.storage_get_empresa();
        params['empresa_sha'] = empresa.codigo_sha;
        return params;
    }

    /** Retorna la data de la empresa
     * {'nombre': '', 'codigo': '', 'codigo_sha': ''}
    */
    storage_get_empresa() {
      return JSON.parse(window.localStorage.getItem('empresa'))
    }

    storage_set_empresa(empresa) {
       window.localStorage.setItem('empresa', JSON.stringify(empresa));
    }

    storage_delete_empresa() {
       window.localStorage.removeItem('empresa')
    }

}


